import { graphql, useStaticQuery } from 'gatsby';

export const useBannerData = () => {
  const { data } = useStaticQuery(graphql`
    query {
      data: bannerDataJson {
        image {
          alt
          image {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
            }
          }
        }
        text
      }
    }
  `);

  return data;
};
